import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Divider, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CollapsedBreadcrumbs from 'common/components/CollapsedBreadcrumbs';
import { getBreadcrumbs } from 'common/components/segment/helpers';
import TitlePreview from 'common/components/segment/TitlePreview';

const HeaderPreview = ({
    currentBreadcrumb,
    handleClickBreadcrumb,
    offerInfoPatern,
}) => {
    const { t } = useTranslation();
    const breadCrumbs = getBreadcrumbs(handleClickBreadcrumb, offerInfoPatern);

    return (
        <Box>
            <Grid container spacing={0} sx={{ p: 2 }}>
                <Grid size={{ lg: 15, md: 14, xs: 13 }}>
                    <TitlePreview name={offerInfoPatern?.projectName} />
                </Grid>

                <Grid size={{ lg: 3, md: 4, xs: 5 }} textAlign="right">
                    <Button
                        onClick={() =>
                            handleClickBreadcrumb(
                                offerInfoPatern.contactId,
                                offerInfoPatern.projectId,
                            )
                        }
                        size="small"
                        startIcon={<ArrowBackIcon fontSize="small" />}
                        variant="text"
                    >
                        {t('Back')}
                    </Button>
                </Grid>

                <Grid size={{ xs: 18 }} sx={{ pl: '40px' }}>
                    <CollapsedBreadcrumbs
                        current={currentBreadcrumb}
                        locations={breadCrumbs}
                    />
                </Grid>
            </Grid>

            <Divider sx={{ mb: 0 }} />
        </Box>
    );
};

HeaderPreview.propTypes = {
    currentBreadcrumb: PropTypes.string,
    handleClickBreadcrumb: PropTypes.func,
    offerInfoPatern: PropTypes.object,
};

export default HeaderPreview;
